module.exports = __webpack_public_path__ + "img/product-placeholder-63.376349d.png";